<template>
  <div class="buyNotic-detail" v-if="buyNotic && buyNotic.length > 0">
    <div class="serve_introduce_title pf-medium buyNotic_title">购买须知</div>
    <div class="block-ui">
      <template v-for="(item, index) in buyNotic">
        <ul class="notice-ul" :key="index + 'key'" v-if="item.value">
          <label class="notice-title">{{ item.name }}</label>
          <ul>
            <li class="notice-sub-li" v-html="item.value"></li>
          </ul>
        </ul>
      </template>
      <template v-if="product.spuBuyNotes && product.spuBuyNotes.length > 0">
        <ul
          class="notice-ul"
          v-for="(item, index) in product.spuBuyNotes"
          :key="index"
        >
          <label class="notice-title">{{ item.noteTitle }}</label>
          <ul v-if="item.contentList && item.contentList.length > 0">
            <li
              class="notice-sub-li"
              v-for="(it, childIndex) in item.contentList"
              :key="childIndex"
              v-html="it"
            ></li>
          </ul>
        </ul>
      </template>
    </div>
  </div>
</template>

<script>
import utils from '@/plugins/utils'
import PROUDCT_TYPE from './config'
import { UNION_YUESAO_ID } from '@/config'

export default {
  props: {
    product: {
      type: Object
    }
  },
  computed: {
    isRebuilding() {
      // 产后恢复
      return (
        this.product &&
        this.product.spuId &&
        +this.product.spuType === PROUDCT_TYPE.YU_ER &&
        this.product.level4CategoryId &&
        parseInt(+this.product.level4CategoryId / 100) === 101121
      )
    },
    isPopYuesao() {
      // 联营月嫂
      return (
        this.product &&
        this.product.spuId &&
        this.product.level4CategoryId == UNION_YUESAO_ID
      )
    },
    buyNotic() {
      //购买须知
      const {
        minMonth,
        maxMonth,
        scheduler,
        purchaseTimes,
        useStartTime,
        useEndTime,
        isSchedule,
        useTermType,
        orderTerm
      } = this.product
      const fitPeople = utils.rangeAge(
        minMonth * 1,
        maxMonth * 1,
        this.isRebuilding
      )
      const sche = typeof scheduler === 'number' ? scheduler : isSchedule
      const reserveInfo = scheduler > 0 ? `请提前${scheduler}天预约` : undefined

      let useTime = ''
      if (!useTermType && useStartTime && useEndTime) {
        useTime = `${utils.dateFormat(
          useStartTime,
          'YY.MM.DD'
        )}到${utils.dateFormat(useEndTime, 'YY.MM.DD')}内使用`
      } else if (useTermType && orderTerm) {
        useTime = orderTerm
      }
      const ruleInfo =
        purchaseTimes > 0 ? `每位用户最多购买${purchaseTimes}份` : '不限'
      if (this.isPopYuesao) {
        return [
          {
            name: '使用期限：',
            value: useTime
          },
          {
            name: '温馨提示：',
            value:
              '请正确填写预产期，如月嫂下户后未及时核销，系统会在<strong>预产期90天后</strong>默认订单已服务完成'
          }
        ]
      }
      if (+this.product.spuType === PROUDCT_TYPE.PLAY_PRODUCT) {
        if (
          this.product &&
          this.product.showTextAttrs &&
          this.product.showTextAttrs.more &&
          this.product.showTextAttrs.more.length > 0
        ) {
          const items = this.product.showTextAttrs.more[0].items
          return [
            ...items,
            {
              name: '使用期限',
              value: useTime
            }
          ]
        }
      }
      return [
        {
          name: '使用期限',
          value: useTime
        },
        {
          name: '适用人群',
          value: fitPeople
        },
        {
          name: '单人可购买份数',
          value: ruleInfo
        },
        {
          name: '是否需要预约',
          value: `${sche > 0 ? '需预约' : '免预约'}`
        },
        {
          name: '提前多久预约',
          value: reserveInfo
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.buyNotic-detail {
  background-color: #fff;
  padding: rem(32px) rem(30px);
  margin-bottom: rem(20px);
  .serve_introduce_title {
    font-size: rem(32px);
    color: #121212;
    line-height: rem(34px);
  }

  .block-ui {
    // padding-top: rem(22px);

    .notice-ul {
      .notice-title {
        height: rem(32px);
        color: #999999;
        font-size: rem(26px);

        display: inline-block;
        margin-top: rem(20px);
      }

      &:first-child {
        .notice-title {
          margin-top: rem(24px);
        }
      }

      ul {
        li {
          color: #121212;
          font-size: rem(26px);

          display: flex;
          align-items: flex-start;
          justify-content: flex-start;

          margin-top: rem(12px);
          line-height: 1.4;

          &::before {
            display: inline-block;
            content: '';
            width: rem(6px);
            height: rem(6px);
            background: #999999;
            border-radius: 50%;
            margin-right: rem(13px);

            flex: 0 0 auto;

            margin-top: rem(14px);
          }
        }
      }
    }
    .one-line {
      display: flex;
      align-items: flex-start;
      font-size: rem(26px);
      padding: rem(10px) 0;
      &:last-child {
        padding-bottom: 0;
      }
      label {
        flex: none;
        min-width: rem(210px);
        color: #4d4d4d;
      }
      label.short {
        min-width: rem(130px);
      }
      div {
        color: #121212;
        flex: auto;
        /deep/ strong {
          color: #ff5900;
          font-weight: 500;
        }
        p {
          line-height: rem(32px);
          padding-bottom: rem(12px);
          &:last-child {
            padding-bottom: 0;
          }
        }
        &.one-line-ul.position-ui {
          display: flex;
          flex-wrap: wrap;
          > p {
            > span {
              display: none;
            }
            &:last-child {
              i {
                display: none;
              }
            }
          }
        }
      }
    }
  }
}
</style>
